import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// One fetch per session — the captions change rarely and every employee
// form, filter bar and attachment picker asks for them.
let cache = null;
let inFlight = null;

/**
 * Polish captions for pick-list *values* (departments, trades, document
 * types, certificate types…). The stored value stays English so reports,
 * filters and exports keep working; only what the user reads changes,
 * and only while they're working in Polish.
 *
 * Captions are maintained in Settings → General and shared with the
 * public application form.
 */
export default function useValueLabels() {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [labels, setLabels] = useState(cache || {});

  useEffect(() => {
    if (cache) return;
    if (!inFlight) {
      inFlight = axios.get(`${API}/settings/value-translations`)
        .then((r) => { cache = r.data?.pl || {}; return cache; })
        .catch(() => { cache = {}; return cache; });
    }
    let alive = true;
    inFlight.then((map) => { if (alive) setLabels(map); });
    return () => { alive = false; };
  }, []);

  const polish = (i18n.language || '').toLowerCase().startsWith('pl');
  return useCallback(
    (value) => (polish && value && labels[value]) || value,
    [polish, labels],
  );
}

/** Drop the cache so a settings save is picked up without a reload. */
export function clearValueLabelCache() {
  cache = null;
  inFlight = null;
}
